export default class LazyLoadImages {

	static init() {
		const lazyImgs = document.querySelectorAll("[loading='lazy']");

		lazyImgs.forEach((img) => {
			if (img.complete && img.naturalHeight !== 0) {
				img.classList.add('lazyloaded');
			} else {
				img.addEventListener('load', (e) => {
					img.classList.add('lazyloaded');
				});
			}
		});
	}
}
